import styled from "styled-components";
import Clouds from "assets/images/jpgs/Clouds.jpg";
import OrangeStudents from "assets/images/jpgs/OrangeStudents.jpg";
import LadySmiling from "assets/images/jpgs/LadySmiling.jpg";
import Donate from "assets/images/jpgs/Donate.png";
import Volunteer from "assets/images/jpgs/Volunteer.png";
import Support from "assets/images/jpgs/Support.png";

const Contact = () => {
  return (
    <div className="relative">
      <div className="md:h-screen mb-10">
        <UpperSection>
          <div className="sm:w-4/5">
            <div className="flex flex-col justify-center items-center m-4 ">
              <div>
                <p className="leading-[19px] text-[16px] sm:mb-5 text-[#FFFFFF]">
                  CONTACT US
                </p>
              </div>
              <div>
                <p className="uppercase sm:text-[25px] lg:text-[40px] mb-5 font-extrabold text-[#FFFFFF]">
                  Let’s Close the needs gap
                </p>
              </div>
              <div className="flex mb-5">
                <div className="flex flex-col gap-4 px-6 justify-center items-center border-r min-h-[97px] border-white">
                  <div>
                    <img src={Donate} alt="Donate items" />
                  </div>
                  <p className="text-[#FFFFFF] leading-[19px] text-[16px]">
                    DONATE
                  </p>
                </div>
                <div className="flex flex-col gap-4 px-6 justify-center items-center  border-r min-h-[97px] border-white">
                  <div>
                    <img src={Volunteer} alt="Volunteer" />
                  </div>
                  <p className="text-[#FFFFFF] leading-[19px] text-[16px]">
                    VOLUNTEER
                  </p>
                </div>
                <div className="flex flex-col gap-4 px-6 justify-center items-center min-h-[97px]">
                  <div>
                    <img src={Support} alt="Support" />
                  </div>
                  <p className="text-[#FFFFFF] leading-[19px] text-[16px]">
                    SUPPORT
                  </p>
                </div>
              </div>
            </div>
          </div>
        </UpperSection>
        <LowerSection>
          <div className="sm:w-4/5 flex justify-center">
            <div className="flex justify-center items-center m-4 md:w-1/2">
              <p className="text-[#7A7A7A] text-[20px] text-center leading-[26px]">
                “Pure religion and undefiled before God and Father is this, to
                visit the fatherless and widows in their afflictions.”
              </p>
            </div>
          </div>

          <BottomSection>
            <div className="flex max-sm:flex-col max-sm:items-center gap-2 justify-between">
              <div>
                <p className="leading-[38px] text-[23px] lg:text-[32px] font-bold">
                  Contact us for info now
                </p>
              </div>
              <div>
                <img src={Donate} alt="Donate items" />
              </div>
              <div>
                <p className="leading-[38px] text-[23px] lg:text-[32px] font-bold">
                  info@truekeepers.org
                </p>
              </div>
            </div>
          </BottomSection>
        </LowerSection>
      </div>
      <div className="max-md:hidden absolute w-4/5 top-5 flex flex-col px-16 max-[450px]:px-8 py-12">
        <div className="flex items-center">
          <div className="w-2/5 mr-8">
            <img
              className="object-cover"
              src={OrangeStudents}
              alt="School students"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;

const UpperSection = styled.div`
  background: linear-gradient(
      0deg,
      rgba(34, 34, 34, 0.3),
      rgba(34, 34, 34, 0.3)
    ),
    url(${Clouds});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 40%;
  display: flex;
  justify-content: end;
  align-items: end;

  @media not all and (min-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
const LowerSection = styled.div`
  height: 60%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: end;
  padding: 4px 64px;

  @media screen and (max-width: 768px) {
    padding: 4px 32px;
  }
`;
const BottomSection = styled.div`
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
    url(${LadySmiling});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  width: 100%;
  min-height: 80px;
`;
